import initialState from '../store/initialState'
import couponsTypes from '../constants/couponsTypes'

export default function couponsReducer(state = initialState.coupons, action) {
  switch (action.type) {

    case couponsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case couponsTypes.reset_coupon: {
      return {
        ...initialState.coupons,
        items: state.items,
        coupon: state.coupon,
        totals: state.totals,
        pagination: state.pagination
      }
    }

    case couponsTypes.clear_coupon: {
      return {
        ...initialState.coupons,
        coupon: {
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
      }
    }
    // GET
    case couponsTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case couponsTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        coupon: action.payload,
        errors: []
      }
    }

    case couponsTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case couponsTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case couponsTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        errors: [],
        coupon: action.payload
      }
    }

    case couponsTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // INDEX
    case couponsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case couponsTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.coupons,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case couponsTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.coupons,
        errors: []
      }
    }

    case couponsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }


    // RESET COUPON CAMPAIGN TOKEN
    case couponsTypes.reset_token.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case couponsTypes.reset_token.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.coupons,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case couponsTypes.reset_token.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }



    // PUBLISH, UNPUBLISH, REVOKE
    case couponsTypes.publish.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case couponsTypes.publish.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.coupons,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case couponsTypes.publish.single:{
      const {status } = action.payload.coupon
      return {
        ...state,
        setting_status: false,
        set_status: true,
        coupon: {
          ...state.coupon,
          status: status,
        }
      };
    }

    case couponsTypes.publish.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }

    // CREATE
    case couponsTypes.create.init: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case couponsTypes.create.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case couponsTypes.create.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        coupon: action.payload,
        errors: []
      }
    }

    case couponsTypes.create.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/couponsReducer.js